(() => {
  const root = document.querySelector('[data-serving-test]');
  if (!root || root.dataset.servingAbReady) return;
  root.dataset.servingAbReady = 'true';
  const line = root.querySelector('[data-serving-price]');
  const handles = ['kitchen-extra-virgin-olive-oil', 'table-extra-virgin-olive-oil', 'the-duo-kitchen-table-extra-virgin-olive-oil'];
  if (!line || root.dataset.servingCurrency !== 'GBP' || !handles.includes(root.dataset.servingProduct)) return;
  const experiment = 'drzzl_serving_v1', key = experiment + '_assignment', ttl = 90 * 86400000;
  if (root.dataset.servingPreview === 'true') {
    line.hidden = new URLSearchParams(location.search).get('drzzl_ab') !== 'B';
    return;
  }
  if (root.dataset.servingTest !== 'running') return;
  let assigned = null, observer = null, exposed = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  function gtag() { window.dataLayer = window.dataLayer || []; window.dataLayer.push(arguments); }
  const expose = () => {
    if (exposed || !allowed() || !assigned) return;
    exposed = true;
    gtag('set', 'user_properties', { drzzl_serving_v1: assigned.arm });
    gtag('event', 'drzzl_experiment_exposure', { send_to: 'G-9S4GTBD50E', experiment_id: experiment, experiment_variant: assigned.arm, product_handle: root.dataset.servingProduct });
    observer?.disconnect();
  };
  const init = () => {
    if (!allowed()) {
      line.hidden = true; observer?.disconnect(); assigned = null;
      try { localStorage.removeItem(key); } catch (_) {}
      return;
    }
    if (assigned) return;
    try {
      const prior = JSON.parse(localStorage.getItem(key) || 'null');
      if (prior && ['A', 'B'].includes(prior.arm) && Number.isFinite(prior.created) && Date.now() - prior.created < ttl && prior.created <= Date.now()) assigned = prior;
      if (!assigned) {
        assigned = { arm: crypto.getRandomValues(new Uint32Array(1))[0] < 2147483648 ? 'A' : 'B', created: Date.now() };
        localStorage.setItem(key, JSON.stringify(assigned));
        if (JSON.parse(localStorage.getItem(key)).arm !== assigned.arm) throw new Error('Assignment unavailable');
      }
    } catch (_) { assigned = null; return; }
    line.hidden = assigned.arm !== 'B';
    const price = root.querySelector('.drzzl-product__price');
    if ('IntersectionObserver' in window && price) {
      observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) expose(); }, { threshold: 0.5 });
      observer.observe(price);
    } else expose();
  };
  document.addEventListener('visitorConsentCollected', init);
  if (window.Shopify?.customerPrivacy) init();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) init(); });
})();